// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var footer = "Footer-module--footer--1ylO3";
export var footerIcons = "Footer-module--footer-icons--2WvH4";
export var footerCopyright = "Footer-module--footer-copyright--2AQnb";
export var footerIcon = "Footer-module--footer-icon--1YY4F";